import { FC } from 'react';
import { Helmet } from 'react-helmet';

// import { useStatusToast } from '~/components/unified/hooks';
import { FormNotification } from './FormNotification';
import { useAccountMembers } from './useAccountMembers';
import { useUserMemberships } from './useUserMemberships';

export const NotificationSettings = ({
  memberships,
  type,
}: {
  memberships: any;
  type: 'user' | 'team';
}) => {
  // const { addSuccessToast } = useStatusToast();

  const handleUpdate = (_value: string) => {
    /**
    addSuccessToast({
      description: `${notificationTitle} notifications have been turned ${
        enabled ? 'ON' : 'OFF'
      } for ${notificationTarget}.`,
      heading: 'Notification settings updated',
    });

     * @todo add addErrorToast to handle error
     */
  };

  return (
    <FormNotification data={memberships} onChange={handleUpdate} type={type} />
  );
};

export const TeamNotificationSettings: FC = () => {
  const { members } = useAccountMembers();

  return <NotificationSettings memberships={members} type="team" />;
};

export const UserNotificationSettings: FC = () => {
  const { loading, memberships } = useUserMemberships();

  return (
    <>
      <Helmet>
        <title>Notification settings</title>
      </Helmet>
      {loading ? (
        <NotificationSettings memberships={memberships} type="user" />
      ) : null}
    </>
  );
};
